import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'how_many_collective_bargaining_agreements_cbas_have_there'

export const dataPointDefinition = {
  retracedId: 'how_many_collective_bargaining_agreements_cbas_have_there',
  name: 'How many Collective Bargaining Agreements (CBAs) have there been in effect at the facility during the assessment timefra',
  description:
    "Collective Bargaining Agreements: Written agreements regarding working conditions and terms of employment concluded between an employer and representative workers' organization(s).",
  meta: {
    slcpMeta: {
      key: 'foa-cb-6',
      number: 'WI-FOA-57',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'foa-cb-6', version: '1.7.0', provider: 'slcp'}],
  sortingId: 27210,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
